import { useEffect, useState } from "react";
import {  useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import { categorySchema } from "../../Validation/Validation";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import CodeEditor from "../../Components/CodeEditor";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";
import Breadcrumb from "../../Components/Breadcrumb";
import ImageUploadMultiple from "../../Components/ImageUploadMultiple";

const AddCategory = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const [qualityData, setQualityData] = useState([]);
  const [traceabilityData, setTraceabilityData] = useState([]);
  const [packSizeData, setPackSizeData] = useState([]);
  const [grindData, setGrindData] = useState([]);

  const fetchAllData = async () => {
    const apiList = [
      {
        url: "quality/getWithoutPaginationQuality",
        setter: setQualityData,
      },
      {
        url: "traceability/getWithoutPaginationTraceability",
        setter: setTraceabilityData,
      },
      {
        url: "packSize/getWithoutPaginationPackSizes",
        setter: setPackSizeData,
      },
      {
        url: "grind/getWithoutPaginationGrind",
        setter: setGrindData,
      },
    ];

    try {
      const responses = await Promise.all(
        apiList.map((item) => axiosInstance.get(item.url)),
      );

      responses.forEach((res, index) => {
        apiList[index].setter(res.data?.data || []);
      });
    } catch (err) {
      setQualityData([]);
      setTraceabilityData([]);
      setPackSizeData([]);
      setGrindData([]);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const initalvalues = {
    categoryName: editData?.categoryName,
    description: editData?.description || "",
    categoryLink: editData?.categoryLink || "",
    thumbnailImage: editData?.thumbnailImage,
    bannerImage: editData?.bannerImage,
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? false,
    metaTitle: editData?.metaTitle || "",
    metaKeywords: editData?.metaKeywords || "",
    metaDescription: editData?.metaDescription || "",
    qualityIds: editData?.qualityIds || [],
    traceabilityIds: editData?.traceabilityIds || [],
    packSizeIds: editData?.packSizeIds || [],
    grindIds: editData?.grindIds || [],
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: categorySchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("categoryName", values.categoryName || "");
        formData.append("description", values.description || "");
        formData.append("categoryLink", values.categoryLink || "");
        formData.append("sortOrder", values.sortOrder);
        formData.append("isActive", values.isActive || false);
        formData.append("metaTitle", values.metaTitle || "");
        formData.append("metaKeywords", values.metaKeywords || "");
        formData.append("metaDescription", values.metaDescription || "");

        if (values.qualityIds.length) {
          values.qualityIds.forEach((id) => {
            formData.append("qualityIds[]", id);
          });
        }

        if (values.packSizeIds.length) {
          values.packSizeIds.forEach((id) => {
            formData.append("packSizeIds[]", id);
          });
        }

        if (values.grindIds.length) {
          values.grindIds.forEach((id) => {
            formData.append("grindIds[]", id);
          });
        }

        if (values.traceabilityIds.length) {
          values.traceabilityIds.forEach((id) => {
            formData.append("traceabilityIds[]", id);
          });
        }

        if (values.thumbnailImage instanceof File) {
          formData.append("thumbnailImage", values.thumbnailImage);
        }
        const existingImages = [];
        values.bannerImage &&
          values.bannerImage?.forEach((file) => {
            if (file instanceof File) {
              formData.append("bannerImage", file);
            } else if (typeof file === "string") {
              existingImages.push(file);
            }
          });
        formData.append("existingBannerImage", JSON.stringify(existingImages));
        const response = editingId
          ? await axiosInstance.put(
              `/category/updateCategory/${editingId}`,
              formData,
            )
          : await axiosInstance.post("/category/createCategory", formData);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/categories", {
            state: {
              currentPage: editData?.currentPage || 1,
              perPage: editData?.perPage || 10,
            },
          });
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Categories", path: "/categories" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Category
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="category-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="category-sortOrder"
                        name="sortOrder"
                        placeholder="Enter category Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="categoryName" className="col-form-label ">
                        Name
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="categoryName"
                        name="categoryName"
                        placeholder="Enter category name"
                        value={values.categoryName || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.categoryName && errors.categoryName && (
                        <small className="text-danger">
                          {errors.categoryName}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="categoryLink" className="col-form-label ">
                        Link
                      </label>
                      <input
                        type="text"
                        className="form-control border border-dark"
                        id="categoryLink"
                        name="categoryLink"
                        placeholder="Enter Category link"
                        value={values.categoryLink}
                        onChange={handleChange}
                      />
                      {touched.categoryLink && errors.categoryLink && (
                        <small className="text-danger">
                          {errors.categoryLink}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="metaTitle" className="col-form-label ">
                        Meta Title
                      </label>
                      <input
                        type="text"
                        className="form-control  border border-dark"
                        id="metaTitle"
                        name="metaTitle"
                        placeholder="Enter meta title"
                        value={values.metaTitle}
                        onChange={handleChange}
                      />
                      {touched.metaTitle && errors.metaTitle && (
                        <small className="text-danger">
                          {errors.metaTitle}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="metaKeywords" className="col-form-label ">
                        Meta Keywords
                      </label>
                      <input
                        type="text"
                        className="form-control  border border-dark"
                        id="metaKeywords"
                        name="metaKeywords"
                        placeholder="Enter meta keywords"
                        value={values.metaKeywords}
                        onChange={handleChange}
                      />
                      {touched.metaKeywords && errors.metaKeywords && (
                        <small className="text-danger">
                          {errors.metaKeywords}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="metaDescription"
                        className="col-form-label"
                      >
                        Meta Description
                      </label>

                      <textarea
                        className="form-control  border border-dark"
                        id="metaDescription"
                        name="metaDescription"
                        placeholder="Enter meta description"
                        value={values.metaDescription}
                        onChange={handleChange}
                        rows={13}
                      />

                      {touched.metaDescription && errors.metaDescription && (
                        <small className="text-danger">
                          {errors.metaDescription}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="category-description"
                        className="col-form-label "
                      >
                        Description
                      </label>

                      <CodeEditor
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                      />

                      {touched.description && errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="category-thumbnailImage"
                      label={`Category Thumbnail Image`}
                      value={values.thumbnailImage}
                      onChange={(file) => setFieldValue("thumbnailImage", file)}
                      error={errors.thumbnailImage}
                      touched={touched.thumbnailImage}
                    />
                  </div>

                  <div className="col-sm-6">
                    <ImageUploadMultiple
                      id="bannerImage"
                      label="Category Banner Images"
                      value={values.bannerImage}
                      onChange={(files) => setFieldValue("bannerImage", files)}
                      error={errors.bannerImage}
                      touched={touched.bannerImage}
                    />
                  </div>

                  <div className="col-md-12 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>

                  <div className="col-md-3 mt-4" style={{borderRight: "1px solid #eee"}}>
                    <div
                      className="d-flex flex-column mb-3"
                      style={{ gap: "10px" }}
                    >
                      <p
                        className="mb-0 fw-semibold"
                        style={{ minWidth: "140px" }}
                      >
                        {" "}
                        Quality :{" "}
                      </p>

                      <label
                        className="d-flex align-items-center mb-0"
                        style={{ cursor: "pointer", gap: "8px" }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            qualityData?.length > 0 &&
                            values.qualityIds.length === qualityData.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setFieldValue(
                                "qualityIds",
                                qualityData.map((item) => item._id),
                              );
                            } else {
                              setFieldValue("qualityIds", []);
                            }
                          }}
                        />
                        <span className="fw-semibold">All</span>
                      </label>
                    </div>

                    <div
                      className="d-flex flex-wrap"
                      style={{ columnGap: "40px", rowGap: "15px" }}
                    >
                      {qualityData?.length > 0 ? (
                        qualityData.map((item) => {
                          const checked = values.qualityIds.includes(item?._id);
                          return (
                            <label
                              key={item?._id}
                              className="d-flex align-items-center mb-0"
                              style={{ gap: "8px", minWidth: "180px" }}
                            >
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setFieldValue("qualityIds", [
                                      ...values.qualityIds,
                                      item?._id,
                                    ]);
                                  } else {
                                    setFieldValue(
                                      "qualityIds",
                                      values.qualityIds.filter(
                                        (id) => id !== item?._id,
                                      ),
                                    );
                                  }
                                }}
                              />
                              <span>{item?.qualityName}</span>
                            </label>
                          );
                        })
                      ) : (
                        <span className="text-danger">No Quality Found</span>
                      )}
                    </div>
                  </div>

          
                  <div className="col-md-3 mt-4" style={{borderRight: "1px solid #eee"}}>
                    <div
                      className="d-flex flex-column mb-3"
                      style={{ gap: "10px",}}
                    >
                      <p
                        className="mb-0 fw-semibold"
                        style={{ minWidth: "140px" }}
                      >
                        Source :
                      </p>

                      <label
                        className="d-flex align-items-center mb-0"
                        style={{ cursor: "pointer", gap: "8px" }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            traceabilityData?.length > 0 &&
                            values.traceabilityIds.length ===
                              traceabilityData.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setFieldValue(
                                "traceabilityIds",
                                traceabilityData.map((item) => item._id),
                              );
                            } else {
                              setFieldValue("traceabilityIds", []);
                            }
                          }}
                        />
                        <span className="fw-semibold">All</span>
                      </label>
                    </div>

                    <div
                      className="d-flex flex-wrap"
                      style={{ columnGap: "40px", rowGap: "15px" }}
                    >
                      {traceabilityData?.length > 0 ? (
                        traceabilityData.map((item) => {
                          const checked = values.traceabilityIds.includes(
                            item?._id,
                          );
                          return (
                            <label
                              key={item?._id}
                              className="d-flex align-items-center mb-0"
                              style={{ gap: "8px", minWidth: "180px" }}
                            >
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setFieldValue("traceabilityIds", [
                                      ...values.traceabilityIds,
                                      item?._id,
                                    ]);
                                  } else {
                                    setFieldValue(
                                      "traceabilityIds",
                                      values.traceabilityIds.filter(
                                        (id) => id !== item?._id,
                                      ),
                                    );
                                  }
                                }}
                              />
                              <span>{item?.traceabilityName}</span>
                            </label>
                          );
                        })
                      ) : (
                        <span className="text-danger">
                          No Source Found
                        </span>
                      )}
                    </div>
                  </div>

                  
                  <div className="col-md-3 mt-4" style={{borderRight: "1px solid #eee"}}>
                    <div
                      className="d-flex flex-column mb-3"
                      style={{ gap: "1opx" }}
                    >
                      <p
                        className="mb-0 fw-semibold"
                        style={{ minWidth: "140px" }}
                      >
                        Pack Size :
                      </p>

                      <label
                        className="d-flex align-items-center mb-0"
                        style={{ cursor: "pointer", gap: "8px" }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            packSizeData?.length > 0 &&
                            values.packSizeIds.length === packSizeData.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setFieldValue(
                                "packSizeIds",
                                packSizeData.map((item) => item._id),
                              );
                            } else {
                              setFieldValue("packSizeIds", []);
                            }
                          }}
                        />
                        <span className="fw-semibold">All</span>
                      </label>
                    </div>

                    <div
                      className="d-flex flex-wrap"
                      style={{ columnGap: "40px", rowGap: "15px" }}
                    >
                      {packSizeData?.length > 0 ? (
                        packSizeData.map((item) => {
                          const checked = values.packSizeIds.includes(
                            item?._id,
                          );
                          return (
                            <label
                              key={item?._id}
                              className="d-flex align-items-center mb-0"
                              style={{ gap: "8px", minWidth: "180px" }}
                            >
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setFieldValue("packSizeIds", [
                                      ...values.packSizeIds,
                                      item?._id,
                                    ]);
                                  } else {
                                    setFieldValue(
                                      "packSizeIds",
                                      values.packSizeIds.filter(
                                        (id) => id !== item?._id,
                                      ),
                                    );
                                  }
                                }}
                              />
                              <span>{item?.packSizeName}</span>
                            </label>
                          );
                        })
                      ) : (
                        <span className="text-danger">No Pack Size Found</span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-3 mt-4" >
                    <div
                      className="d-flex flex-column mb-3"
                      style={{ gap: "10px" }}
                    >
                      <p
                        className="mb-0 fw-semibold"
                        style={{ minWidth: "140px" }}
                      >
                        Grinds :
                      </p>

                      <label
                        className="d-flex align-items-center mb-0"
                        style={{ cursor: "pointer", gap: "8px" }}
                      >
                        <input
                          type="checkbox"
                          checked={
                            grindData?.length > 0 &&
                            values.grindIds.length === grindData.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setFieldValue(
                                "grindIds",
                                grindData.map((item) => item._id),
                              );
                            } else {
                              setFieldValue("grindIds", []);
                            }
                          }}
                        />
                        <span className="fw-semibold">All</span>
                      </label>
                    </div>

                    <div
                      className="d-flex flex-wrap"
                      style={{ columnGap: "40px", rowGap: "15px" }}
                    >
                      {grindData?.length > 0 ? (
                        grindData.map((item) => {
                          const checked = values.grindIds.includes(item?._id);

                          return (
                            <label
                              key={item?._id}
                              className="d-flex align-items-center mb-0"
                              style={{ gap: "8px", minWidth: "180px" }}
                            >
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setFieldValue("grindIds", [
                                      ...values.grindIds,
                                      item?._id,
                                    ]);
                                  } else {
                                    setFieldValue(
                                      "grindIds",
                                      values.grindIds.filter(
                                        (id) => id !== item?._id,
                                      ),
                                    );
                                  }
                                }}
                              />

                              <span>{item?.grindName}</span>
                            </label>
                          );
                        })
                      ) : (
                        <span className="text-danger">No Grind Found</span>
                      )}
                    </div>
                  </div>

                  
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                    <Button
                    color="danger"
                    className="mx-2"
                    onClick={() =>
                      navigator("/categories", {
                        state: {
                          currentPage: editData?.currentPage || 1,
                          perPage: editData?.perPage || 10,
                          search: editData?.search || "",
                        },
                      })
                    }
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCategory;
